import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupersetEmbeddedService {

  private URL = environment.api + "api/superset";

  constructor(private http: HttpClient) {}

  getGuest(dashboardId: any) {
    return this.http.get(`${this.URL}/guest-token/${dashboardId}`)
  }
}